<template lang="pug">
  .layout-view
    .layout-view__controls
      v-btn(@click="modals.showDetail = true")
        v-icon(
          position-left
          font-size="1"
          icon="plus")
        | {{ 'base.add_group' | translate }}

    //- TABLE
    table.table.table--bars
      thead
        tr.table__row.table__row--head
          th.table__cell {{ 'base.name' | translate }}
          th.table__cell
      v-table-body(
        :cols="2"
        :loading="!loaded"
        :empty="!items.length")
        template(v-slot="{ isToggled, toggleRow }")
          template(v-for="item in items")

            //- TABLE ROW
            tr.table__row(:class="{ 'table__row--merge-bottom': isToggled(item) }")
              td.table__cell {{ item.name }}
              td.table__cell.table__cell--action
                v-btn.mr-1(
                  icon
                  @click="onEditOpen(item)")
                  v-icon(
                    font-size="1"
                    icon="cog")
                v-btn.tg-btn(
                  icon
                  @click="toggleRow(item)")
                  v-chevron(:value="isToggled(item)")

            //- ROW EXTENDED
            tr.table__row.table__row--merge-top(
              v-if="isToggled(item)")
              td.table__cell.p-0(
                colspan="2")
                table.table
                  thead
                    tr.table__row.table__row--head
                      th.table__cell {{ 'base.perm' | translate }}
                      th.table__cell {{ 'base.perm_view' | translate }}
                      th.table__cell {{ 'base.perm_add' | translate }}
                      th.table__cell {{ 'base.perm_change' | translate }}
                      th.table__cell {{ 'base.perm_delete' | translate }}
                  tbody
                    tr.table__row(
                      v-for="item in item.settings"
                      :key="item.id")
                      td.table__cell {{ `perm.${item.label}.${item.name}` | translate }}
                      td.table__cell
                        toggle-dot(:value="item.view")
                      td.table__cell
                        toggle-dot(:value="item.add")
                      td.table__cell
                        toggle-dot(:value="item.change")
                      td.table__cell
                        toggle-dot(:value="item.delete")

    //- DIALOG
    v-dialog(
      max-width="950"
      v-model="modals.showDetail")
      detail-dialog(
        :settings="options.settings"
        :selected="selectedItem"
        @update="loadData"
        @close="onClose")
</template>

<script>
import api from '@/api'

import ToggleDot from '@/components/common/toggle-dot/ToggleDot'
import DetailDialog from './dialogs/DetailDialog.vue'

export default {
  name: 'Groups',

  components: {
    ToggleDot,
    DetailDialog
  },

  mounted () {
    this.loadData()
    this.loadSettingsOptions()
  },

  data: () => ({
    modals: {
      showDetail: false
    },
    options: {
      settings: []
    },
    items: [],
    selectedId: null,
    loaded: false
  }),

  computed: {
    selectedItem () {
      return this.items.find(item => item.id === this.selectedId)
    }
  },

  methods: {
    async loadData () {
      const { data, error } = await api.permissions.list()
      if (!error) {
        this.items = data
      }
      this.loaded = true
    },

    async loadSettingsOptions () {
      const { data, errors } = await api.permissions.settings()
      this.options.settings = !errors
        ? data
        : []
    },

    onClose () {
      this.selectedId = null
      this.modals.showDetail = false
    },

    onEditOpen (item) {
      this.selectedId = item.id
      this.modals.showDetail = true
    },

    onCreateOpen () {
      this.selectedId = null
      this.modals.showDetail = true
    }
  }
}
</script>

<style scoped>
.table__cell:first-child {
  width: 85%;
}

.table__cell.table__cell--action {
  width: 15%;
  text-align: right !important;
}

.table__row--merge-top /deep/ .table__cell:nth-child(1) {
  width: 55%;
}
.tg-btn {
  transform: translateY(-2px);
}
</style>